import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/trustpilot_logo_black.svg")